import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MARKETING_ORIGIN } from "../utils/origins";

/** Send leftover marketing / legal / deep-link paths to fam.life. */
const MarketingRedirect = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    window.location.replace(`${MARKETING_ORIGIN}${pathname}${search}${hash}`);
  }, [hash, pathname, search]);

  return null;
};

export default MarketingRedirect;
